<template>
  <div class="" v-loading="loading">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" label-width="150px" class="ruleForm">
      <!-- <el-row type="flex" :gutter="20" justify="">
        <el-col :span="24">
          <el-form-item label="封面图片" prop="coverPic">
            <uploadFile ref="uploadFile" :fileUrl="ruleForm.coverPic" :tipText="tipText" :maxSize="1" @remove-file="() => onRemove('ruleForm', 'coverPic')" @upload-success="res => uploadSuccess(res, 'ruleForm', 'coverPic')" />
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row type="flex" :gutter="20" justify="">
        <el-col :span="12">
          <el-form-item label="资讯名称" prop="newsTitle">
            <el-input v-model="ruleForm.newsTitle" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="ruleForm.sort" type="number" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row type="flex" :gutter="20" justify="">
        <el-col :span="12">
          <el-form-item label="类型" prop="newsType">
            <el-select v-model="ruleForm.newsType" placeholder="请选择">
              <el-option label="行业动态" :value="1"></el-option>
              <el-option label="采门动态" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row type="flex" justify="">
        <el-col :span="24">
          <el-form-item label="正文内容" prop="newsContent">
            <template #label>
              <span>正文内容</span>
              <span style="color: #bdbaba">（图片上传最大支持 10 MB，支持常见图片格式如 jpg、png、gif 等；视频上传最大支持 200MB，支持 mp4、ogg、webm、avi 等格式）</span>
            </template>
            <editor :htmls="ruleForm.newsContent" @change="onChange" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="btn">
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
// import uploadFile from "@/components/uploadFile.vue"
import editor from "@/components/editor.vue"
function createForm() {
  return {
    // coverPic: "",
    sort: "",
    newsTitle: "",
    newsType: "",
    newsContent: "",
  }
}
export default {
  components: {
    editor,
    // uploadFile
  },
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      loading: false,
      ruleForm: createForm(),
      rules: {
        newsTitle: [{ required: true, message: "请输入内容", trigger: "blur" }],
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        // newsType: [{ required: true, message: "请选择", trigger: "change" }],
        // coverPic: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
      tipText: "建议尺寸：192px × 128px，图片大小不能超过 10 MB",
    }
  },
  created() {
    switch (this.type) {
      case "1":
        document.title = "新增动态"
        break
      case "2":
        document.title = "修改动态"
        this.getInfo()
        break
      case "3":
        document.title = "查看动态"
        this.getInfo()
        break
    }
  },
  methods: {
    getInfo() {
      this.loading = true
      this.$axios
        .get(this.$api.newsInfoselectDetail, {
          params: {
            id: this.id,
          },
        })
        .then(res => {
          this.ruleForm = { ...res.result }
          this.$set(this.ruleForm, "newsContent", res.result.newsContent)
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onRemove(form, str) {
      this.$set(this[form], str, "")
    },
    uploadSuccess(res, form, str) {
      this.$set(this[form], str, res)
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.loading = true
          let params = {
            newsTitle: this.ruleForm.newsTitle,
            sort: this.ruleForm.sort,
            // newsType: this.ruleForm.newsType,
            newsContent: this.ruleForm.newsContent,
            // coverPic: this.ruleForm.coverPic,
          }
          let api = ""
          if (this.type == 1) {
            api = this.$api.newsInfoinsert
          } else {
            api = this.$api.newsInfoupdate
            params.id = this.id
          }
          this.$axios
            .post(api, params)
            .then(res => {
              this.loading = false
              this.$message.success(`${this.type == 2 ? "修改" : "新增"}成功`)
              this.$router.go(-1)
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("提交失败")
          return false
        }
      })
    },
    onChange(value) {
      this.ruleForm.newsContent = value
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="scss">
.ruleForm {
  margin: 30px auto;
  padding: 0 50px;
  .el-select {
    width: 100%;
  }
}
.btn {
  text-align: center;
  margin: 20px 0;
  .el-button {
    width: 120px;
  }
}
</style>
